<div class="modal fade show" tabindex="-1" role="dialog" aria-labelledby="modalTitle" style="display: block;" aria-modal="true">
  <div class="modal-dialog modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title" id="modalTitle">
          {{title}}
        </h4>
        <button type="button" class="close" (click)="close(false)" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <div [innerHTML]="message | safe:'html'"></div>
        <div *ngIf="!!listMessage" [innerHTML]="listMessageHtml | safe:'html'" ></div>
      </div>
      <div class="modal-footer">
          <button type="button" class="btn btn-info waves-effect waves-light mr-1" (click)="close(true)">{{acceptButtonText}}</button>
          <button type="button" *ngIf="showCancel" class="btn btn-secondary" (click)="close(false)">{{cancelButtonText}}</button>
      </div>
    </div>
  </div>
</div>
